import {Injectable} from '@angular/core';
import {urlJoin} from '../../../../../utils/urlJoin';
import {environment} from '../../../../../../environments/environment';
import {SearchObject} from '../../../../../domain/search/SearchObject';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Response} from '../../../../../domain';
import {map} from 'rxjs/operators';
import {LOCAL_SERVER_SOURCES, USE_SOURCE_FROM_EXTERNAL_PATHS} from '../../../../../domain/source-paths/external-paths';
import {CommonServciesService} from '../../../acheteur/procedure-passation/common-servcies.service';

export interface umInfo {
    supTelNo: string;
    instEmail: string;
    supBizRegNo: string;
    instHpage: string;
    instAddr1: string;
    supCnssId: string;
    instAddr2: string;
    slfFaxNo: string;
    instPostCd: string;
    chfIndRegNo: string;
    slfMtelNo: string;
    chfMtelNo: string;
    chfChfNm: string;
    instTelNo: string;
    supFaxNo: string;
    slfPositionNm: string;
    slfUserId: string;
    instInstNm: string;
    slfStaffNm: string;
    instFaxNo: string;
    supHpage: string;
    supSupplierNm: string;
    slfTelNo: string;
    instRegNo: string;
    instMtelNo: string;
    supAddr2: string;
    supAddr1: string;
    supTaxId: string;
    supPostCd: string;
    slfEmail: string;
    slfStaffDeptNm: string;
    instPositionNm: string;
}

export interface userInfot {
    INSTU_TEL_NO: string;
    bidUrl: string;
    INSTU_EMAIL: string;
    exmsUrl: string;
    INSTU_STAFF_NM: string;
    serverCertInfo: string;
    INSTU_FAX_NO: string;
    INSTU_REG_ID: string;
    INSTU_STAFF_DEPT_NM: string;
    INSTU_POSITION_NM: string;
    INSTU_MTEL_NO: string;
}

@Injectable({
    providedIn: 'root',
})
export class AvisAOService {

    localServer = environment.localServer;
    servlet = environment.servlet;

    constructor(private http: HttpClient, private commonService: CommonServciesService) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'fournisseur');
    }

    source(host, port) {
        return host + ':' + port;
    }

    search(searchObject: SearchObject) {
        const resource = urlJoin(AvisAOService.base, 'bid', 'data');
        return this.http.post(resource, searchObject);
    }

    makeSubmissionInProgress(obj) {
        const resource = urlJoin(AvisAOService.base, 'bid', 'block', 'submission?'+`bidNo=${obj.bidNo}&bidModSeq=${obj.bidModSeq}&bizRegNo=${obj.bizRegNo}`);
        return this.http.post(resource, null);
    }

    checkSubmissionInProgress(obj) {
        const resource = urlJoin(AvisAOService.base, 'bid', 'check', 'submission?'+`bidNo=${obj.bidNo}&bidModSeq=${obj.bidModSeq}&bizRegNo=${obj.bizRegNo}`);
        return this.http.get(resource);
    }

    deleteSubmissionInProgress(obj) {
        const resource = urlJoin(AvisAOService.base,'bid', 'delete', 'submission?'+`bidNo=${obj.bidNo}&bidModSeq=${obj.bidModSeq}&bizRegNo=${obj.bizRegNo}`);
        return this.http.delete(resource);
    }



    savewithcrypt(list) {
        const resource = ((flag) => {
            if (flag) {
                const reqParams = {
                    docCode: 'Bid',
                    operation: 'ENC2',
                };
                return urlJoin(this.source(this.localServer.host, this.localServer.port), LOCAL_SERVER_SOURCES.SEND + this.commonService.getReqParamsPath(reqParams));
            } else {
                return 'https://localhost:28080/sign/send?docCode=Bid&operation=ENC2';
            }
        })(USE_SOURCE_FROM_EXTERNAL_PATHS);

        return this.http.post(resource, list);
    }

    savewithcryptgroup(list) {
        const resource = ((flag) => {
            if (flag) {
                const reqParams = {
                    docCode: 'CooperationSupplyDemandAgreement',
                    operation: 'SIG',
                };
                return urlJoin(this.source(this.localServer.host, this.localServer.port), LOCAL_SERVER_SOURCES.SEND + this.commonService.getReqParamsPath(reqParams));
            } else {
                return 'https://localhost:28080/sign/send?docCode=CooperationSupplyDemandAgreement&operation=SIG';
            }
        })(USE_SOURCE_FROM_EXTERNAL_PATHS);

        return this.http.post(resource, list);
    }

    savewithcryptdossiercandidature(list) {
        const resource = ((flag) => {
            if (flag) {
                const reqParams = {
                    docCode: 'ProcuringExaminationApplication',
                    operation: 'SIG',
                };
                return urlJoin(this.source(this.localServer.host, this.localServer.port), LOCAL_SERVER_SOURCES.SEND + this.commonService.getReqParamsPath(reqParams));
            } else {
                return 'https://localhost:28080/sign/send?docCode=ProcuringExaminationApplication&operation=SIG';
            }
        })(USE_SOURCE_FROM_EXTERNAL_PATHS);

        return this.http.post(resource, list);
    }

    getBidUserInfo(bidNo, bidModSeq) {
        const resource = urlJoin(AvisAOService.base, 'vUmInst', 'info');
        return this.http
            .get<Response<userInfot>>(resource, {
                params: new HttpParams()
                    .set('bidNo', bidNo)
                    .set('bidModSeq', bidModSeq),
            })
            .pipe(map((response) => response.payload));
    }

    getselectUmInst(instBizRegNo) {
        const resource = urlJoin(AvisAOService.base, 'vUmInst');
        return this.http
            .get<Response<any>>(resource, {
                params: new HttpParams().set('instBizRegNo', instBizRegNo),
            })
            .pipe(map((response) => response.payload));
    }

    getsselectEpBidDocRegNoChk(bidNo, bidModSeq, bizRegNo, flag) {
        const resource = urlJoin(AvisAOService.base, 'vEpBidCheked', 'flag');
        return this.http
            .get<Response<any>>(resource, {
                params: new HttpParams()
                    .set('bidNo', bidNo)
                    .set('bidModSeq', bidModSeq)
                    .set('bizRegNo', bizRegNo)
                    .set('flag', flag),
            })
            .pipe(map((response) => response.payload));
    }

    loadCotioData(options) {
        const resource = urlJoin(AvisAOService.base, 'vEpSupportGuarantee', 'data');

        return this.http.post(resource, options);
    }

    loadRequtesList(options) {
        const resource = urlJoin(AvisAOService.base, 'vBidObjection', 'data');

        return this.http.post(resource, options);
    }

    loadPropList(options) {
        const resource = urlJoin(
            AvisAOService.base,
            'vEpPt',
            'searchWithPagination'
        );

        return this.http.post(resource, options);
    }

    loadCandList(options) {
        const resource = urlJoin(
            AvisAOService.base,
            'vEpPq',
            'searchWithPagination'
        );

        return this.http.post(resource, options);
    }

    loadProcPreData(options) {
        const resource = urlJoin(AvisAOService.base, 'vEpPqBid', 'data');

        return this.http.post(resource, options);
    }

    getCandInfo(bidNo, bidModSeq) {
        const resource = urlJoin(AvisAOService.base, 'vEpPq', 'selectEpPq');
        return this.http
            .get<Response<any>>(resource, {
                params: new HttpParams()
                    .set('bidNo', bidNo)
                    .set('bidModSeq', bidModSeq),
            })
            .pipe(map((response) => response.payload));
    }
}


/*
{
  params: new HttpParams()
      .set("shopNo", shopNo)
      .set("shopModSeq", shopModSeq),
})*/
